import { LS } from "src/config/constants";

export const CONNECTOR = {
  METAMASK: "metamask",
  WALLET_CONNECT: "walletconnect",
};

export const getConnectedWallet = () => {
  return window.localStorage.getItem(LS.CONNECTOR);
};

export const setConnectedWallet = (wallet) => {
  if (!wallet) {
    window.localStorage.removeItem(LS.CONNECTOR);
  } else {
    window.localStorage.setItem(LS.CONNECTOR, wallet);
  }
};

export const setChainId = (chainId) => {
  window.localStorage.setItem(LS.CHAIN_ID, chainId);
};
